import { render, staticRenderFns } from "./DetailPenerbitanBerusaha.vue?vue&type=template&id=54d886df&"
import script from "./DetailPenerbitanBerusaha.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanBerusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports